import type { OrganizerBlockDto } from '@upme/contracts';
import { Button } from '@upme/ui/components/button';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@upme/ui/components/table';
import { toast } from 'sonner';
import { useUnblockOrganizer } from '../mutations';

const dateFmt = new Intl.DateTimeFormat('ru-RU', { dateStyle: 'medium', timeStyle: 'short' });

export function OrganizerBlocksTable({ blocks }: { blocks: OrganizerBlockDto[] }) {
  const unblock = useUnblockOrganizer();

  if (blocks.length === 0) {
    return <p className="text-sm text-muted-foreground">Заблокированных организаторов нет.</p>;
  }

  const onUnblock = async (b: OrganizerBlockDto) => {
    if (!window.confirm(`Разблокировать @${b.username}? Его новые посты снова будут публиковаться.`)) return;
    try {
      await unblock.mutateAsync(b.id);
      toast.success(`@${b.username} разблокирован`);
    } catch {
      toast.error('Не удалось разблокировать');
    }
  };

  return (
    <Table>
      <TableHeader>
        <TableRow>
          <TableHead>Организатор</TableHead>
          <TableHead>Причина</TableHead>
          <TableHead>Заблокировал</TableHead>
          <TableHead className="text-right">Действия</TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {blocks.map((b) => (
          <TableRow key={b.id}>
            <TableCell>
              <a href={`https://t.me/${b.username}`} target="_blank" rel="noreferrer" className="underline">
                @{b.username}
              </a>
            </TableCell>
            <TableCell className="whitespace-pre-wrap">{b.reason}</TableCell>
            <TableCell>
              <div>{b.blockedBy?.name ?? '—'}</div>
              <div className="text-xs text-muted-foreground">{dateFmt.format(new Date(b.createdAt))}</div>
            </TableCell>
            <TableCell className="text-right">
              <Button variant="outline" size="sm" disabled={unblock.isPending} onClick={() => onUnblock(b)}>
                Разблокировать
              </Button>
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
}
